window.addEventListener('load', () => {
  Utils.init();
  setHeaderEvent();
  AOS.init({once: true});
});

/**
 * 공통함수
 */
const Utils = {
  /**
   * Set default event
   */
  init: () => {
    Utils.setDatepicker();
    Utils.setTableCheckbox();
    Utils.setValidation();
    Utils.setCustomDropdownSelect();
    Utils.setDropdown();
    Utils.setSelect2();
    Utils.setToastr();
  },
  /**
   * Set Search Dropdown
   */
  setToastr() {
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "progressBar": true,
      "positionClass": "toast-top-center",
      "onclick": null,
      "showDuration": "500",
      //"hideDuration": "5000",
      "timeOut": "4000",
      "extendedTimeOut": "4000",
      "showEasing": "swing",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut",
    }
  },
  /**
   * Set Search Dropdown
   */
  setDropdown() {
    $(document).on('click', '.dropdown .dropdown-item', function () {
      let $parent = $(this).closest('.dropdown');
      let $searchTitle = $parent.find('.dropdown-toggle');
      let $dropInput = $parent.find('input');
      $searchTitle.html($(this).html());
      $dropInput.val($(this).data('value'));
      //$searchTitle.data('value', $(this).data('value'));
    });
    //$(document).on('click', '#searchForm .dropdown .dropdown-item', function () {
    //  let $parent = $(this).closest('.dropdown');
    //  let $searchTitle = $parent.find('#searchTitle');
    //  $searchTitle.text($(this).text());
    //});
  },
  /**
   * Set Datepicker
   */
  setDatepicker() {
    let $datepicker = $('.datepicker');
    $datepicker.datepicker({ dateFormat: 'yy년 m월 d일' });
    $datepicker.datepicker().datepicker('setDate', 'today');
  },
  /**
   * Set Tooltip
   */
  setTooltip() {
    $('[data-toggle="tooltip"]').tooltip({
      content: function () {
        return $(this).prop('title');
      },
    });
    $('.detail-custom-tab [data-toggle="tab"]').tooltip({
      content: function () {
        return $(this).prop('title');
      },
    });

    $('[data-placement="top"]').tooltip({
      position: {
        my: 'center bottom',
        at: 'center top-8',
      },
    });
    $('[data-placement="right"]').tooltip({
      position: {
        my: 'left center',
        at: 'right+8 center',
      },
    });
    $('[data-placement="bottom"]').tooltip({
      position: {
        my: 'center top',
        at: 'center bottom+8',
      },
    });
    $('[data-placement="left"]').tooltip({
      position: {
        my: 'right center',
        at: 'left-8 center',
      },
    });
  },
  /**
   * Set Table Checkbox
   */
  setTableCheckbox() {
    $(document).on('change', '.ta-table-wrap input.all', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $eachCheckboxList = $tableWrap.find('input.each');
      $eachCheckboxList.prop('checked', $(e.target).prop('checked'));
    });
    $(document).on('change', '.ta-table-wrap input.each', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $allCheckbox = $tableWrap.find('input.all');
      let $eachLength = $tableWrap.find('input.each').length;
      let $eachCheckedLength = $tableWrap.find('input.each:checked').length;
      if ($eachLength == $eachCheckedLength) {
        $allCheckbox.prop('checked', true);
      } else {
        $allCheckbox.prop('checked', false);
      }
    });
  },
  /**
   * Set Validation
   */
  setValidation() {
    let elements = document.querySelectorAll('input, textarea');
    for (let i = 0; i < elements.length; i++) {
      elements[i].oninvalid = function (e) {
        e.target.setCustomValidity(' ');
        if (!e.target.validity.valid) {
          elements[i].classList.add('is-invalid');
          if (e.target.type == 'file') {
            // label.classList.remove('btn-primary');
            // label.classList.add('btn-danger');
          }
        } else {
          if (e.target.type != 'file') {
            elements[i].classList.remove('is-invalid');
          } else {
            // label.classList.add('btn-primary');
            // label.classList.remove('btn-danger');
          }
        }
      };
      elements[i].oninput = function (e) {
        e.target.setCustomValidity(' ');
      };
      if ($(elements[i]).attr('required')) {
        elements[i].focusout = () => {
          // elements[i].classList.remove('is-valid');
          elements[i].classList.remove('is-invalid');
          if (elements[i].value == null || elements[i].value == '') {
            elements[i].classList.add('is-invalid');
          } else {
            // elements[i].classList.add('is-valid');
          }
        };
      }
    }
  },
  /**
   * Set Custom Select
   * if Change Select Call setCustomDropdownSelect(id);
   * @param {String} tagId
   */
  setCustomDropdownSelect(tagId = null) {
    const createCustomDropdownSelect = function (el) {
      let $originalSelect = $(el);
      let $originalOptgroupList = $originalSelect.find('optgroup');
      let $originalOptionList = $originalSelect.find('option');
      let placeholder = '선택';
      let isPlaceholder = false;
      if ($(el).parent().find('.custom-dropdown-select').length <= 0) {
        let newSelect = `
        <div class="dropdown custom-dropdown-select">
        <button class="btn dropdown-toggle" type="button" id="${$originalSelect.attr('id')}Dropdown" ${
          $originalSelect.attr('disabled') ? 'tabindex="-1"' : ''
        } data-toggle="dropdown" aria-expanded="false">
        ${placeholder}
        </button>
        <div class="dropdown-menu" aria-labelledby="${$originalSelect.attr('id')}Dropdown">
        `;
        if ($originalOptgroupList.length > 0) {
          for (let i = 0; i < $originalOptgroupList.length; i++) {
            $originalOptionList = $originalOptgroupList.eq(i).find('option');
            newSelect += `
            <div class="dropdown-optgroup">
            <h6>${$originalOptgroupList[i].label}</h6>
            `;
            for (let j = 0; j < $originalOptionList.length; j++) {
              if ($originalOptionList[j].value == '_placeholder') {
                isPlaceholder = true;
                placeholder = $originalOptionList[j].textContent;
              } else {
                newSelect += `
                <a href="javascript:void(0)"
                class="dropdown-item ${$($originalOptionList[j]).prop('selected') ? 'active' : ''}"
                data-value="${$originalOptionList[j].value}"
                data-toggle="tooltip" data-placement="bottom"
                title="${$originalOptionList[j].title}">
                ${$originalOptionList[j].text}
                </a>
                `;
              }
            }
            newSelect += '</div>';
          }
        } else {
          for (let i = 0; i < $originalOptionList.length; i++) {
            if ($originalOptionList[i].value == '_placeholder') {
              isPlaceholder = true;
              placeholder = $originalOptionList[i].textContent;
            } else {
              newSelect += `
              <a href="javascript:void(0)"
              class="dropdown-item ${$($originalOptionList[i]).prop('selected') ? 'active' : ''}"
              data-toggle="tooltip" data-placement="bottom"
              data-value="${$originalOptionList[i].value}"
              title="${$originalOptionList[i].title}">
              ${$originalOptionList[i].text}</a>
              `;
            }
          }
        }
        newSelect += `
        </div>
        </div>
        `;
        $originalSelect.after(newSelect);
        $originalSelect.next().find('.btn').text(placeholder);

        if ($(el).parent().find('a.dropdown-item.active').length > 0) {
          $('#' + $originalSelect.attr('id') + 'Dropdown').text($(el).parent().find('a.dropdown-item.active').text());
        } else {
          if (isPlaceholder) {
            $(el).parent().find('.custom-dropdown-select').addClass('dropdown-placeholder');
          }
        }
      }
    };
    if (tagId == null) {
      let $customSelect = $('.ta-custom-dropdown-select-wrap select');
      $(document).off('click', '.ta-custom-dropdown-select-wrap .custom-dropdown-select .dropdown-item');
      $(document).on('click', '.ta-custom-dropdown-select-wrap .custom-dropdown-select .dropdown-item', function () {
        let $this = $(this);
        let $originalSelect = $this.parents('.ta-custom-dropdown-select-wrap').find('select');
        let $originalOptionList = $originalSelect.find('option:not([value="_placeholder"]');
        let $index = $this.parents('.dropdown-menu').find('.dropdown-item').index($this);
        let $btn = $this.parents('.custom-dropdown-select').find('.btn');
        $originalOptionList.eq($index).prop('selected', true);
        $originalSelect.trigger('change');
        $btn.text($this.text());
        $btn.parent().removeClass('dropdown-placeholder');
        $this.parents('.dropdown-menu').find('.dropdown-item').removeClass('active');
        $this.addClass('active');
        $originalSelect.removeClass('is-invalid');
        $originalSelect.closest('div').parent().find('.invalid-feedback').remove();
      });
      $customSelect.each((index, el) => {
        createCustomDropdownSelect(el);
      });
    } else {
      let $originalSelect = $(`#${tagId}`);
      $originalSelect.parent().find('.custom-dropdown-select').remove();
      createCustomDropdownSelect($(`#${tagId}`)[0]);
    }
    Utils.setTooltip();
  },
  /**
   * Start Loading
   */
  startLoading() {
    let wrapElmnt = document.querySelector('.spinner-wrap');

    if (wrapElmnt) {
      wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) + 1;
    } else {
      wrapElmnt = document.createElement('div');
      wrapElmnt.classList.add('spinner-wrap');
      wrapElmnt.dataset.task = 1;
      let loadingElmnt = document.createElement('div');
      loadingElmnt.classList.add('spinner-border');
      let span = document.createElement('span');
      span.classList.add('sr-only');
      span.innerHTML = 'Loading...';
      loadingElmnt.appendChild(span);
      wrapElmnt.appendChild(loadingElmnt);

      let body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'hidden';
      body.appendChild(wrapElmnt);
    }
  },
  /**
   * End Loading
   */
  endLoading() {
    setTimeout(function () {
      let wrapElmnt = document.querySelector('.spinner-wrap');

      if(wrapElmnt) {
        let taskCount = wrapElmnt.dataset.task;

        if (taskCount > 1) {
          wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) - 1;
        } else {
          wrapElmnt.style.opacity = 0;
          setTimeout(function () {
            wrapElmnt.remove();
          }, 300);
          let body = document.getElementsByTagName('body')[0];
          body.style.overflow = 'auto';
        }
      }
    }, 300);
  },
  /**
   * Ajax
   * ex) Utils.request('GET', 'test.json', null, (data) => { console.log(data) });
   * @param {String} type
   * @param {String} url
   * @param data
   * @param {Function} func
   */
  request(type, url, data, func) {
    $.ajax({
      type,
      url,
      data,
      success: (data) => {
        func(data);
      },
      error: (xhr, status, error) => {
        console.log(`status: ${status}\nmessage: ${error}`);
      },
    });
  },
  /**
   * Number to KRW format
   * ex) 1000000 -> 1,000,000
   * @param {Number} value
   * @returns {String}
   */
  numberFormatter(value) {
    if (value != '' && value != null && typeof value == 'number') {
      value = String(value)
        .replace(/[^\d]+/g, '')
        .replace(/(^0+)/, '')
        .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    } else {
      value = 0;
    }
    return value === '' ? 'NaN' : value;
  },
  /**
   * Get input[type=file] detail
   * @param {Element} elmnt
   * @returns {Object}
   */
  getFileDetail(elmnt) {
    //파일 경로.
    let filePath = elmnt.value;
    //전체경로를 \ 나눔.
    let filePathSplit = filePath.split('\\');
    // 파일 전체명
    let originalFileName = filePathSplit[filePathSplit.length - 1];
    //파일확장자 앞 .의 index
    let lastDot = originalFileName.lastIndexOf('.');
    //파일명 : .으로 나눈 앞부분
    let fileName = originalFileName.substring(0, lastDot);
    //파일 확장자 : .으로 나눈 뒷부분
    let fileExt = originalFileName.substring(lastDot + 1, originalFileName.length).toLowerCase();
    //파일 크기
    let fileSize = elmnt.files[0].size;

    let object = {
      originalName: originalFileName,
      name: fileName,
      ext: fileExt,
      size: fileSize,
    };

    return object;
  },
  /**
   * Byte to size
   * return ex) 5 GB
   * @param {Number} byte
   * @returns {String}
   */
  byteFormatter(byte) {
    let sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
    if (byte == 0) return '0 Byte';
    let i = parseInt(Math.floor(Math.log(byte) / Math.log(1024)));
    return Math.round(byte / Math.pow(1024, i), 2) + ' ' + sizes[i];
  },
  /**
   * Set date format
   * @param {String} date
   * @returns {Object}
   */
  dateFormatter(date) {
    if ((date == '' || date == null) && typeof date == 'string') {
      return '';
    }
    const addZero = (num, digits) => {
      var zero = '';
      num = num.toString();

      if (num.length < digits) {
        for (var i = 0; i < digits - num.length; i++) {
          zero += '0';
        }
      }
      return zero + num;
    };
    // Safari Invalid Date 로 인한 replace
    date = date.substring(0, date.lastIndexOf('.')).replace(/-/g, '/').replace('T', ' ');
    let newDate = new Date(date);

    let yyyy = newDate.getFullYear();
    let mm = addZero(newDate.getMonth() + 1, 2);
    let m = newDate.getMonth() + 1;
    let dd = addZero(newDate.getDate(), 2);
    let d = newDate.getDate();

    let object = {
      slash: yyyy + '/' + mm + '/' + dd,
      dot: yyyy + '.' + mm + '.' + dd,
      dash: yyyy + '-' + mm + '-' + dd,
      word: yyyy + '년 ' + m + '월 ' + d + '일',
    };

    return object;
  },

  /** 
   * setSelect2
  **/
  setSelect2() {
    const $select2List = $('select.select2');

    $select2List.each(function() {
      let placeholder = $(this).attr('data-placeholder');
      let options = {
        allowClear: true,
        language: {
          noResults: function noResults() {
            return '검색 결과가 없습니다.';
          },
        },
      }
      if(placeholder != null && placeholder != '' && $(this).val() == null) {
        options['placeholder'] = placeholder;
        $(this).val('');
      }
      $(this).select2(options);
    });
    $(document).on('click', '.select2-selection__rendered', function() {
      if($('.select2-search__field')[0] != null) {
        $('.select2-search__field')[0].focus();
        //console.log($('.select2-selection__rendered'));
      }
    })
  },

};

function textareaHeight() {
  let $textarea = $('textarea[readonly]');
  for(let i=0; i<$textarea.length; i++) {
    //$($textarea[i]).css('height', 'auto');
    $($textarea[i]).height( $textarea[i].scrollHeight );
    $($textarea[i]).css("overflow", "hidden");
    if($($textarea[i]).hasClass('collapse-hide')) {
      $($textarea[i]).parents('.collapse').removeClass('show')
    }
  }
};

function setHeaderEvent() {
  const $btnMobileMenu = $('.navbar-nav.mobile a');
  const $mobileMenu = $('.navbar.mobile');
  const $navItem = $('.layout-header .navbar-nav .nav-item');
  const $navLink = $('.navbar-brand, .layout-header .navbar-nav li > a');

  // #region mobile menu event
  $btnMobileMenu.on('click', () => {
    $('.layout-header').append('<div class="header-backdrop modal-backdrop fade"></div>');
    $mobileMenu.addClass('active');
    $mobileMenu.addClass('visible');
    setTimeout(() => {
      $('.header-backdrop').addClass('show');
    }, 100);
  });
  $(document).on('click', '.header-backdrop, .btn-navbar-close', () => {
    $('.header-backdrop').removeClass('show');
    $mobileMenu.removeClass('active');
    setTimeout(() => {
      $('.header-backdrop').remove();
      $mobileMenu.removeClass('visible');
    }, 300);
  });
  // #endregion mobile menu event
  // #region tab event
  $navItem.on('focusin', function () {
    removeMenuActive();
    $(this).addClass('active');
  });
  $navItem.on('click', function () {
    $navItem.removeClass('active-only');
    $(this).addClass('active-only');
    $(this).removeClass('active');
  });
  $navLink.on('focusin', function () {
    removeMenuActive();
  });
  $(document).on('mousedown', function () {
    removeMenuActive();
  });
  $('.layout-main, .layout-footer').on('focusin', function () {
    removeMenuActive();
  });
  function removeMenuActive() {
    $('.layout-header .navbar-nav .nav-item').removeClass('active');
  }
  // #endregion tab event
}

function applyCheckbox(listWrap) {
  let eachCheckedLength = 0;
  // 체크 전체
  $(listWrap).on('change', 'input.all', (e) => {
    let $eachCheckboxList = $(listWrap).find('input.each');
    $eachCheckboxList.prop('checked', !$(e.target).prop('checked'));
    // 숫자 나타내기
    eachCheckedLength = $(listWrap).find('input.each:checked').length;
    $(listWrap).find('.btn-apply').find('span').text(eachCheckedLength);
    if(eachCheckedLength == 0) {
      $(listWrap).find('.btn-apply').prop('disabled', true);
    } else {
      $(listWrap).find('.btn-apply').prop('disabled', false);
    }
  });

  $(listWrap).on('change', 'input.each', (e) => {
    let $allCheckbox = $(listWrap).find('input.all');
    //let eachLength = $(listWrap).find('input.each').length;
    eachCheckedLength = $(listWrap).find('input.each:checked').length;
    if (eachCheckedLength > 0) {
      $allCheckbox.prop('checked', false);
    } else {
      $allCheckbox.prop('checked', true);
    }
    // 숫자 나타내기
    $(listWrap).find('.btn-apply').find('span').text(eachCheckedLength);
    if(eachCheckedLength == 0) {
      $(listWrap).find('.btn-apply').prop('disabled', true);
    } else {
      $(listWrap).find('.btn-apply').prop('disabled', false);
    }
  });
};

/*** input file ***/
$(document).on('change', 'input[type=file]', function (e) {
  let $label = $(e.target).parents('.input-file-wrap').find('.input-label');
  $label.html($label.data('placeholder'));
  $(e.target).parents('.input-file-wrap').removeClass('is-file');
  readfile(e.target);
});

function readfile(input, receiveFile) {
  // 이미 있는 파일값 정보 가져오기
  if(receiveFile) {
    let file = receiveFile.split('/').slice(-1).split('.');
    //let filetype = file.pop();
    let filePath = window.URL.createObjectURL(receiveFile);
    let filename = file.join(receiveFile.split('/').slice(-1));

    $(input).parent().addClass('is-file');
    $(input).parent().find('.input-label').html(`
    <a href="${filePath}" download>
      <i class="material-icons">file_present</i> 
      <span class="name">${filename}</span>
    </a>
    `);
  } 
  // 인풋 태그에 파일이 있는 경우
  else if(input.files && input.files[0]) {
    let filePath = window.URL.createObjectURL(input.files[0]);
    let filename = input.files[0].name;

    $(input).parent().addClass('is-file');
    $(input).parent().find('.input-label').html(`
    <a href="${filePath}" download>
      <i class="material-icons">file_present</i> 
      <span class="name">${filename}</span>
    </a>
    `);
  }
}
$(document).on('click', '.btn-file-remove', function () {
  $(this).parents('.input-file-wrap').removeClass('is-file');
  let $label = $(this).parents('.input-file-wrap').find('.input-label');
  $label.html($label.data('placeholder'));

  let $input = $(this).parents('.input-file-wrap').find('input');
  $input.val('');
});
/* 사진 첨부 끝 */

//원하는 인풋 부모에 .focus 추가
function inputWrapFocus(parent) {
  $(document).on('focus', `${parent} input`, function() {
    $(this).parents(`${parent}`).addClass('focus');
  })
  $(document).on('focusout', `${parent} input`, function() {
    $(this).parents(`${parent}`).removeClass('focus');
  })
}

// form 안에 모든 input에 값이 있어야 버튼이 활성화 된다.
function btnDisabled(btn) {

  let $formSelect = $(btn).parents('form').find('select');
  let selectValue = $formSelect.length <= 0 ? true : false;
  let $formInput = $(btn).parents('form').find('input');
  let inputValue;
  let requireCheck = true;

  function checkInputAndBtn() {
    inputValue = true;
    for(let i=0; i<$formInput.length; i++) {
      if($formInput[i].value == '') {
        inputValue = false;
      }
    }
    let btnDisabled = selectValue && inputValue && requireCheck ? false : true ;
    $(`${btn}`).attr('disabled', btnDisabled);
  }

  // form에 select가 있는경우 값이 있는지 찾기
  if(!selectValue) {
    $(document).on('change', 'form .input-wrap select', function() {
      selectValue = true;
      for(let i=0; i<$formSelect.length; i++) {
        if($formSelect[i].value == '') {
          selectValue = false;
        }
      }
      checkInputAndBtn()
    });
  }
  // form에 checkbox require 있는경우 값이 있는지 찾기
  let $formCheckBox = $(btn).parents('form').find('.require[type=checkbox]');
  if($formCheckBox.length > 0) {
    requireCheck = false;
    $(document).on('change', 'form .input-wrap .require[type=checkbox]', function() {
      requireCheck = $formCheckBox.is(':checked');
      checkInputAndBtn();
    });
  }

  $(document).on('keyup', 'form .input-wrap input', function() {
    checkInputAndBtn();
  });
}

// 마이페이지 tab
// 분양 절차 안내 ㅅ뮤
function tab() {
  let tabTarget = $('.tab-nav .tab-nav-item.active').data('target');
  $(tabTarget).css('display', 'block');

  $(document).on('click', '.tab-nav .tab-nav-item', function() {
    $('.tab-nav .tab-nav-item').removeClass('active');
    $(this).addClass('active');
    tabTarget = $(this).data('target');
    $('.tab-content > *').css('display', 'none');
    $(tabTarget).css('display', 'block');

    // 모바일에서 모달을 열 경우
    let ModalTaget = $(this).data('modal-target');
    let windowWidth =  window.outerWidth;
    if(ModalTaget != null && windowWidth < 1280) {
      $(ModalTaget).modal('show');
    }
  });
}

function covidTab() {
  $('.tab-content').css('display', 'none');
  let tabTarget = $('.covid-nav-wrap .active').data('target');
  $(tabTarget).css('display', 'block');

  $(document).on('click', '.covid-nav-wrap a', function() {
    //타겟에 맞는거 active
    $('.covid-nav-wrap a').removeClass('active');
    tabTarget = $(this).data('target');
    $(`.covid-nav-wrap [data-target="${tabTarget}"]`).addClass('active');
    // 드롭다운 toggle 변경
    $('.covid-nav.moblie .dropdown-toggle').html($('.covid-nav.moblie a.active').html());
    // 타겟에 맞는 content 보여주기
    $('.tab-content').css('display', 'none');
    $(tabTarget).css('display', 'block');
  });
}

function indexSwiper() {
  const keySwiper = new Swiper('.key-swiper', {
    loop: true,
    speed: 1500,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1.001,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 1.001,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 1.001,
        spaceBetween: 40,
      }
    },

    //slidesPerView: 1.5,
    centeredSlides: true,
    
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".key-swiper .swiper-button-next",
      prevEl: ".key-swiper .swiper-button-prev",
    }
  });

  $(".key-swiper .swiper-pause").click(function(){
    keySwiper.autoplay.stop();
    $(this).css('display', 'none');
    $(".key-swiper .swiper-play").css('display', 'block');
  });

  $(".key-swiper .swiper-play").click(function(){
    keySwiper.autoplay.start();
    $(this).css('display', 'none');
    $(".key-swiper .swiper-pause").css('display', 'block');
  });
  
  const researchSwiper = new Swiper('.research-swiper', {
    breakpoints: {
      320: {
        slidesPerView: "auto",
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    },
    navigation: {
      nextEl: ".research-swiper .swiper-button-next",
      prevEl: ".research-swiper .swiper-button-prev",
    }
  });

  if(window.innerWidth >= 1280) {
    opacity();
  } else {
    $('.research-swiper .swiper-slide').css('opacity', '1');
  }
  function opacity() {
    $('.research-swiper .swiper-slide').css('opacity', '1');
    $('.research-swiper .swiper-slide.swiper-slide-active').prev().css('opacity', '0.2');
    $('.research-swiper .swiper-slide.swiper-slide-active').prev().prev().css('opacity', '0.2');
    $('.research-swiper .swiper-slide.swiper-slide-active').next().next().next().next().css('opacity', '0.2');
    $('.research-swiper .swiper-slide.swiper-slide-active').next().next().next().next().next().css('opacity', '0.2');
  }
  $('.research-swiper .swiper-button-next').on('click', function() {
    const swiper = researchSwiper;
    const slidesPerView = swiper.params.slidesPerView;
    swiper.slideTo(swiper.activeIndex + slidesPerView - 1);
    opacity();
  });
  
  $('.research-swiper .swiper-button-prev').on('click', function() {
    const swiper = researchSwiper;
    const slidesPerView = swiper.params.slidesPerView;
    swiper.slideTo(swiper.activeIndex - slidesPerView + 1);
    opacity();
  });

}

function infoSwiper() {
  const keySwiper = new Swiper('.info-swiper', {
    loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".info-swiper .swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".info-swiper .swiper-button-next",
      prevEl: ".info-swiper .swiper-button-prev",
    },
  });
}

function listSwiper() {
  const keySwiper = new Swiper('.list-swiper', {
    //loop: true,
    slidesPerView: 1,
    pagination: {
      el: ".list-swiper .swiper-pagination",
      clickable: true,
    },
  });
}

function symtomsListSwiper() {
  const keySwiper = new Swiper('.symtoms-list-swiper', {
    //loop: true,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 24,
    pagination: {
      el: ".symtoms-list-swiper .swiper-pagination",
      clickable: true,
    },
  });
}

const cohortColorArr = ['#46d6bf', '#4aa7fb', '#ffe164', '#ffbd6a', '#ff8b7a', '#83f4eb', '#86c0fd', '#fde99f', '#fdd8aa', '#fcbd6a', '#46d6bf', '#3880f1', '#f4d35c', '#ffbd2c', '#f99043'];
const cohortColorHoverArr = ['#2abfa7', '#188ffa', '#ffd731', '#ffa637', '#ff5f47', '#54f0e3', '#54a6fc', '#fcde6d', '#fcc178', '#fba738', '#2abfa7', '#1063e6', '#f1c62c', '#f8aa00', '#f77312'];

function makeDoughnutChart(chartID, doughnutData) {
  let $legend = $(chartID).parents('.chart-container').find('.legend');
  // 이전꺼 지우고 다시 넣기
  const $parent = $(chartID).parent();
  $(chartID).remove();
  $legend.empty();
  $(chartID).parents('.chart-container').find().empty();
  $parent.append(`<canvas id=${chartID}></canvas>`);

  var customTooltips = function (tooltipModel) {
    let tooltip = document.getElementById('chartjsTooltip');
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.id = 'chartjsTooltip';
      this._chart.canvas.parentNode.appendChild(tooltip);
    } else {
      $(tooltip).empty();
    }

    // Hide if no tooltip
    if (tooltipModel.opacity === 0) {
      tooltip.style.opacity = 0;
      return;
    }

    // show the tooltip.
    tooltip.style.opacity = 1;

    //Create text below image
    const tooltipText = document.createElement('div');
    tooltipText.className = 'tooltip-text';

    const textIndex = tooltipModel.dataPoints[0].index;

    let tooldataList = doughnutData.tooldata[textIndex].list;
    let toolUl = '';
    for(let i=0; i<tooldataList.length; i++) {
      toolUl += '<li>' + tooldataList[i] + '</li>';
    }
    tooltipText.innerHTML = `
      <p class="bold">${this._data.labels[textIndex]}</p>
      <p>${doughnutData.tooldata[textIndex].text}</p>
      <ul>${toolUl}</ul>
    `;
    tooltip.appendChild(tooltipText);

    // Set caret Position
    tooltip.classList.remove('above', 'below', 'no-transform');
    if (tooltip.yAlign) {
      tooltip.classList.add(tooltipModel.yAlign);
    } else {
      tooltip.classList.add('no-transform');
    }

    var positionY = this._chart.canvas.offsetTop;
    var positionX = this._chart.canvas.offsetLeft;

    // Display, position, and set styles for font
    tooltip.style.opacity = 1;
    tooltip.style.left = positionX + tooltipModel.caretX + 'px';
    tooltip.style.top = positionY + tooltipModel.caretY*2 + 'px';
    let cleft = positionX + tooltipModel.caretX + 'px';
    let ctop = positionY + tooltipModel.caretY*2 + 'px';

    if(window.innerWidth < 1280 && window.innerWidth >= 786) {
      tooltip.style.left = '50%';
      tooltip.style.top = '90%';
    } else if(window.innerWidth < 786) {
      tooltip.style.left = '50%';
      tooltip.style.top = '100%';
    }
    //console.log('positionY: ' + positionY + ' // positionX: ' + positionX);
    //console.log('left: ' + cleft + ' // top: ' + ctop);

  };
  

  let chartData = {
    labels: doughnutData['labelArr'],
    datasets: [
      {
        label: 'slices',
        borderWidth: 0,
        data: doughnutData['dataArr'],
        backgroundColor: cohortColorArr,
        hoverBackgroundColor: cohortColorHoverArr,
      },
    ],
  };
  let chartOptions = {
    responsive: true,
    aspectRatio: 1,
    layout: {
      padding: 0
    },
    plugins: {
      legend: false,
      labels: false,
    },
    tooltips: {
      mode: 'index',
      intersect: true,
      enabled: false,
      custom: customTooltips,
    }
  };

  const myChart = new Chart(chartID, {
    type: 'doughnut',
    data: chartData,
    options: chartOptions,
  });

  let count = doughnutData['dataArr'].length;

  const lagend_left = document.createElement('ul');

  for (let i = 0; i < count; i++) {
    const li_left = document.createElement('li');

    li_left.innerHTML = `
      <span style="background-color:${cohortColorArr[i]};"></span>
      ${doughnutData['labelArr'][i]}
    `;

    lagend_left.append(li_left);
    //document.getelementsbyclassname('donutData').append(text);
  }
  $legend.append(lagend_left);
}

// bar 차트 라운드 주는 함수
function roundedBar() {
  // draws a rectangle with a rounded top
  Chart.helpers.drawRoundedTopRectangle = function(ctx, x, y, width, height, radius) {
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    // top right corner
    ctx.lineTo(x + width - radius, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
    // bottom right	corner
    ctx.lineTo(x + width, y + height);
    // bottom left corner
    ctx.lineTo(x, y + height);
    // top left	
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.closePath();
  };

  Chart.elements.RoundedTopRectangle = Chart.elements.Rectangle.extend({
    draw: function() {
      var ctx = this._chart.ctx;
      var vm = this._view;
      var left, right, top, bottom, signX, signY, borderSkipped;
      var borderWidth = vm.borderWidth;

      if (!vm.horizontal) {
        // bar
        left = vm.x - vm.width / 2;
        right = vm.x + vm.width / 2;
        top = vm.y;
        bottom = vm.base;
        signX = 1;
        signY = bottom > top? 1: -1;
        borderSkipped = vm.borderSkipped || 'bottom';
      } else {
        // horizontal bar
        left = vm.base;
        right = vm.x;
        top = vm.y - vm.height / 2;
        bottom = vm.y + vm.height / 2;
        signX = right > left? 1: -1;
        signY = 1;
        borderSkipped = vm.borderSkipped || 'left';
      }

      // Canvas doesn't allow us to stroke inside the width so we can
      // adjust the sizes to fit if we're setting a stroke on the line
      if (borderWidth) {
        // borderWidth shold be less than bar width and bar height.
        var barSize = Math.min(Math.abs(left - right), Math.abs(top - bottom));
        borderWidth = borderWidth > barSize? barSize: borderWidth;
        var halfStroke = borderWidth / 2;
        // Adjust borderWidth when bar top position is near vm.base(zero).
        var borderLeft = left + (borderSkipped !== 'left'? halfStroke * signX: 0);
        var borderRight = right + (borderSkipped !== 'right'? -halfStroke * signX: 0);
        var borderTop = top + (borderSkipped !== 'top'? halfStroke * signY: 0);
        var borderBottom = bottom + (borderSkipped !== 'bottom'? -halfStroke * signY: 0);
        // not become a vertical line?
        if (borderLeft !== borderRight) {
          top = borderTop;
          bottom = borderBottom;
        }
        // not become a horizontal line?
        if (borderTop !== borderBottom) {
          left = borderLeft;
          right = borderRight;
        }
      }

      // calculate the bar width and roundess
      var barWidth = Math.abs(left - right);
      var roundness = this._chart.config.options.barRoundness || 0.5;
      var radius = barWidth * roundness * 0.5;
      
      // keep track of the original top of the bar
      var prevTop = top;
      
      // move the top down so there is room to draw the rounded top
      top = prevTop + radius;
      var barRadius = top - prevTop;

      ctx.beginPath();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = borderWidth;

      // draw the rounded top rectangle
      Chart.helpers.drawRoundedTopRectangle(ctx, left, (top - barRadius + 1), barWidth, bottom - prevTop, barRadius);

      ctx.fill();
      if (borderWidth) {
        ctx.stroke();
      }

      // restore the original top value so tooltips and scales still work
      top = prevTop;
    },
  });

  Chart.defaults.bar = Chart.helpers.clone(Chart.defaults.bar);

  Chart.controllers.bar = Chart.controllers.bar.extend({
    dataElementType: Chart.elements.RoundedTopRectangle
  });

}

function makeBarChart(chartID, chartLabels, chartData) {
  let datasetArr = [];
  let dataInner = {};
  for(let i=0; i<chartData.length; i++) {
    dataInner = {
      label: chartData[i].label,
      data: chartData[i].dataArr,
      borderColor: cohortColorArr[i],
      backgroundColor: cohortColorArr[i],
      hoverBackgroundColor: cohortColorArr[i],
      barPercentage: 0.5,
      categoryPercentage: 0.7,
      datalabels: { anchor: 'end', align: 'end' }
    }
    datasetArr.push(dataInner);
  }
  // draws a rectangle with a rounded top
  roundedBar();

  var ctx = document.getElementById(chartID).getContext("2d");

  const myChart = new Chart(ctx, {
    plugins: [ChartDataLabels],
    type: 'bar',
    data: {
      labels: chartLabels,
      datasets: datasetArr,
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      barRoundness: 0.5,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          gridLines: {
            //display: false
            drawOnChartArea: false,
            //drawTicks: false,
            //tickMarkLength: 10
            borderDashOffset: false
          },
          ticks: {
            beginAtZero: true,
            sampleSize: 50,
            //max: 400,
            fontColor: "#434e5a",
          }
        }],
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            fontColor: "#434e5a",
          }
        }],
      },
      plugins: {
        datalabels: {
          color: '#49525d',
          display: function (context) {
            if (window.innerWidth < 1280) {
              return false;
            } else {
              return true;
            }
          },
          font: {
            size: 14,
            weight: '500',
          },
        },
      },
      onResize: function () {
        //myChart.options.layout.padding = getPadding();
        myChart.update();
      },
    }
  });
}


function updateFilter(tableName, val) {
  tableName.setFilter("title", "like", val);
  $('.table-container .no-data .search-text').text(val);
}

function dataTable(tableID, titleName, tabledata) {
  let valueEl = document.getElementById("filter-value");

  const noData = `
    <div class="no-data">
      <div class="wrap">
        <h4>‘<span class="search-text"></span>’와(과) 일치하는 검색결과 0건</h4>
        <div class="no-data-img"><span class="sr-only">no-data image</span></div>
        <p>검색어와 일치하는 결과가 없습니다. <br>단어의 수를 줄이거나, 일반적인 검색어로 다시 검색해보세요.</p>
        <button type="button" class="btn btn-outline-secondary btn-reset">검색어 초기화</button>
      </div>
    </div>
  `;

  const emptyData = `
  <div class="no-data">
    <div class="wrap">
      <div class="no-data-img"><span class="sr-only">no-data image</span></div>
      <p>시스템에 등록된 공지사항이 없습니다.</p>
    </div>
  </div>`

  //var cellClassFormatter = function(cell, formatterParams){
  //  console.log(cell.getElement())
  //  $(cell.getElement()).addClass("check-shin");

  //  return cell.getValue();
  //};

  let dataKey = Object.keys(tabledata[0]);
  let columnsArr = [
    {title:"No", field:"no", sorter: "number", },
    {title:titleName, field:"title", formatter:"link", formatterParams:{url:function(cell){return cell.getData().url}}, hozAlign:"left", cssClass:"title"},
  ];

  for(let i=0; i<dataKey.length; i++) {
    if(dataKey[i] == 'author') {
      columnsArr.push({title:"저자", field:"author", cssClass:"author"});
    } else if(dataKey[i] == 'date') {
      columnsArr.push({title:"게시일자", field:"date", sorterParams :{ format : "YY-MM-DD" }, cssClass:"date"});
    } else if(dataKey[i] == 'writer') {
      columnsArr.push({title:"작성자", field:"writer", cssClass:"writer"});
    } else if(dataKey[i] == 'status') {
      let col = {title: "상태", field: "status", cssClass:"status", formatter: function(cell) {
        var status = cell.getValue();
        var className;
        if (status === "답변대기") {
          className = "gray";
        } else if (status === "답변완료") {
          className = "green";
        } else if (status === "답변중") {
          className = "yellow";
        } else {
          className = "default";
        }
        return "<span class='badge badge-" + className + "'>" + status + "</span>";
      }};
      columnsArr.push(col);      
    }
  }


  let check = false;
    
  const dataTable = new Tabulator(`#${tableID}`, {
    data:tabledata,           //load row data from array
    layout:"fitColumns",      //fit columns to width of table
    responsiveLayout:"hide",  //hide columns that dont fit on the table
    addRowPos:"top",          //when adding a new row, add it to the top of the table
    history:true,             //allow undo and redo actions on the table
    pagination:"remote",       //paginate the data
    paginationSize:10,         //allow 7 rows per page of data
    //paginationSizeSelector:[10, 20, 50, 100],
    paginationCounter:"rows", //display count of paginated rows in footer
    //placeholder: noData,  
    placeholder: check == true ? emptyData : noData,
    movableColumns:true,      //allow column order to be changed
    initialSort:[             //set the initial sort order of the data
      {column: "no", dir:"desc"},
    ],
    columnDefaults:{
      tooltip:false,         //show tool tips on cells
      headerSort:false,
      sorter:"false",
      hozAlign:"center",
    },
    //columns:[                 //define the table columns
    //  {title:"No", field:"no", sorter: "number", },
    //  {title:"연구성과", field:"title", formatter:"link", formatterParams:{url:function(cell){return cell.getData().url}}, hozAlign:"left", },
    //  {title:"저자", field:"author",  },
    //  {title:"게시일자", field:"date", sorterParams :{ format : "YY-MM-DD" }, },
    //  {title:"작성자", field:"writer", },
    //  {title:"작성자", field:"state", },
    //],
    columns: columnsArr,
  });

  let $views = $('.table-container .filter-wrap .table-views');
  $views.on('change', function() {
    dataTable.setPageSize($views.val());
  });
  //window.addEventListener("resize", function() {
  //  if (window.innerWidth < 1280) {
  //    // 창의 너비가 768보다 작을 때 테이블 data 10개만
  //    $('.table-container .filter-wrap .table-views').val('10').trigger('change');
  //  }
  //})

  document.getElementById("filter-value").addEventListener("keyup", function(event) {
    if (event.keyCode === 13) {
      updateFilter(dataTable, $(this).val())
      setTimeout(() => $('.table-container .no-data .search-text').html($('#filter-value').val()), 300);
    }
  });

  $('.table-container').on('click', '.btn-reset', function() {
    dataTable.clearFilter(true); 
    $('.table-container #filter-value').val('');
  }); 
}


function researchNav() {
  $('.research-nav-wrap').on('click', '.research-nav a', function () {
    // PC
    $('.research-nav a').removeClass('active');
  });
  // PC
  $('.research-nav-wrap').on('click', '.research-nav.desktop a', function () {
    $('.research-nav.desktop a').removeClass('active');
    $(this).addClass('active');
    // 클릭한 a 값의 코호트
    let cohort = $(this).data('cohort');
    // 모바일에서도 acitve 넣기
    $(`.research-nav.moblie a[data-cohort=${cohort}]`).trigger('click');
  });

  // Moblie
  $('.research-nav-wrap').on('click', '.research-nav.moblie a', function () {
    $('.research-nav.moblie a').removeClass('active');
    $(this).addClass('active');
    // 클릭한 a 값의 코호트
    let cohort = $(this).data('cohort');
    // PC에서도 acitve 넣기
    $(`.research-nav.desktop a`).removeClass('active');
    $(`.research-nav.desktop a[data-cohort=${cohort}]`).addClass('active');
  });
};

function AddInsertFile() {
  $(document).on('click', '.btn-add-file', function() {
    let $parent = $(this).parent();
    let $insertFile = $parent.find('.input-file-wrap').last();
    let $addInsertFile = $insertFile.clone();
    // idx 구하기
    let inputID = $insertFile.find('input').attr('id').split('_')[0];
    let inputIdx = parseInt($insertFile.find('input').attr('id').split('_')[1]) + 1;
    $addInsertFile.removeClass('is-file');
    $addInsertFile.find('input').attr('id', `${inputID}_${inputIdx}`);
    $addInsertFile.find('input').val('');
    $addInsertFile.find('label').attr('for', `${inputID}_${inputIdx}`);
    $addInsertFile.find('.input-label').html($addInsertFile.find('.input-label').data('placeholder'));

    $insertFile.after($addInsertFile);
  });
}